import { Controller } from 'react-hook-form';
import {
  ButtonPrimary,
  ButtonPseudo,
  ButtonType,
  IconArrowLeft,
  IconLoader,
  InputPassword,
  InputText,
} from '@ui/src';
import { AuthFormTypes } from './types';

import cn from './styles.module.css';
import sharedStyles from '../shared.module.css';

const AuthForm = ({
  control,
  onSubmit,
  requestInProgress,
  toggleShowForgotPass,
  forgotPasswordVisible,
  errors,
  globalError,
}: AuthFormTypes): React.JSX.Element => (
  <form className={sharedStyles.form} onSubmit={onSubmit}>
    <h3>Sign In</h3>
    {globalError && (
      <div className={sharedStyles.globalErrorMessage}>{globalError}</div>
    )}
    <fieldset className={sharedStyles.inputGroup}>
      <div className={sharedStyles.formGroup}>
        <Controller
          control={control}
          defaultValue=""
          name="email"
          render={({ field: { onChange, value } }) => (
            <InputText
              placeholder="Login"
              name="email"
              value={value}
              onChange={onChange}
              error={errors.email?.message}
              disabled={requestInProgress}
            />
          )}
        />
      </div>
      <div className={sharedStyles.formGroup}>
        <Controller
          control={control}
          defaultValue=""
          name="password"
          render={({ field: { onChange, value } }) => (
            <InputPassword
              placeholder="Password"
              name="password"
              value={value}
              onChange={onChange}
              error={errors.password?.message}
              disabled={requestInProgress}
            />
          )}
        />
      </div>
    </fieldset>
    <div className={sharedStyles.authButtons}>
      <ButtonPrimary
        type={ButtonType.SUBMIT}
        icon={requestInProgress ? <IconLoader /> : undefined}
        text={requestInProgress ? '' : 'Sign In'}
        bold
      />
      <ButtonPseudo
        text="Forgot password or login?"
        onClick={() => toggleShowForgotPass(!forgotPasswordVisible)}
        bold
      />
    </div>
    <div
      className={`${cn.authForgotPassword} ${
        forgotPasswordVisible && cn.active
      }`}
    >
      <h3>Forgot password</h3>
      <p>
        If you forgot your password or login, then contact your administrator.
      </p>
      {/* <a
        href={`mailto: ${process.env.ADMIN_MAIL}`}
        target="_blank"
        rel="noreferrer"
      >
        {process.env.ADMIN_MAIL}
      </a> */}
      <ButtonPseudo
        text="Back to login"
        onClick={() => toggleShowForgotPass(!forgotPasswordVisible)}
        icon={<IconArrowLeft />}
        bold
      />
    </div>
  </form>
);

export default AuthForm;
